import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function TwitterShareIconOutlined(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.44838 3.58887C3.26969 3.33577 3.46568 3 3.7921 3H8.08378C8.43023 3 8.75332 3.16187 8.94301 3.43048L13.2013 9.46044L18.9107 3H20.7974L14.038 10.6469L20.9323 20.4111C21.111 20.6642 20.915 21 20.5886 21H16.297C15.9505 21 15.6274 20.8381 15.4377 20.5695L10.9206 14.1727L4.88672 21H3L10.0839 12.9875L3.44838 3.58887ZM5.62531 4.38304L11.828 13.0166L16.6067 19.6703H18.741L12.2623 10.6521L7.75959 4.38304H5.62531Z"
      />
    </SvgIcon>
  );
}
